import { DashboardAction } from '../actions/Dashboard';
import * as Constants from '../constants/action-constants';
import initialState from '../InitialState';
import { Dashboard } from '../types/Dashboard';

const dashboard = (
  state: Dashboard = initialState.dashboard,
  action: DashboardAction
): Dashboard => {
  switch (action.type) {
    case Constants.REQUEST_APPS:
      return {
        ...state,
        fetching: true,
        failed: false
      };
    case Constants.REQUEST_APPS_FAILED:
      return {
        ...state,
        fetching: false,
        failed: true
      };
    case Constants.REQUEST_APPS_SUCCESS:
      //hardcoded
      const cloudObj = {
        vmid: 'cloud',
        transactionId: null,
        icon: 'cloudP.svg',
        name: 'VMwareCloud',
        displayName: 'VMware Cloud',
        description: 'VMware Public Cloud Proxy Manager',
        detailedDescription: 'string',
        accessOrder: 8,
        enabled: true,
        licensed: true,
        appUrl: '/lcm/cloud'
      };
      // action.payload.apps.push(cloudObj)
      return {
        ...state,
        apps: [...action.payload.apps, cloudObj],
        fetching: false
      };
    default:
      return state;
  }
};

export default dashboard;
